import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer">
            <div className="left">
                <p>Stuart Gavidia</p>
                <p>Pacific Lutheran University</p>
                <p>Personal Portfolio</p>
            </div>
            <div className="right">
                <p>gavidisa@plu.edu</p>
                <p>253 507 0953</p>
                <p>linkedin.com/in/StuartGavidia</p>
            </div>
        </div>
    )
}

export default Footer